/**
 * Note: Dodgy in that we're going from partial to non-partial
 */
export function isMetadataWithDocumentData(withMetadata) {
    return typeof withMetadata === "object" && "documentData" in withMetadata;
}
/**
 * Note: Dodgy in that we're going from partial to non-partial
 */
export function isMetadata(withMetadata) {
    // Was: checking that the metadata field was filled in with `&& !!withMetadata?.metadata`
    // But had to drop that because we seem to have WriteMetaData without any meta data in test data
    return typeof withMetadata === "object" && "data" in withMetadata;
}
//# sourceMappingURL=guards.js.map